import * as RadixContextMenu from '@radix-ui/react-context-menu';
import { Children, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type ContextMenuProps = RadixContextMenu.ContextMenuContentProps & {
  trigger: RadixContextMenu.ContextMenuTriggerProps['children'];
  onOpenChange?: RadixContextMenu.ContextMenuProps['onOpenChange'];
};

export const ContextMenu = memo(
  ({ children, trigger, onOpenChange, className, collisionPadding = 8, ...restOfProps }: ContextMenuProps) => {
    return (
      <RadixContextMenu.Root dir="ltr" modal={false} onOpenChange={onOpenChange}>
        <RadixContextMenu.Trigger asChild>{trigger}</RadixContextMenu.Trigger>
        {!!Children.count(children) && (
          <RadixContextMenu.Portal>
            <RadixContextMenu.Content
              className={cn(
                'z-portal flex max-h-[var(--radix-context-menu-content-available-height)] w-[216px] min-w-[var(--radix-popper-anchor-width)] radix-side-left:animate-slide-down radix-side-right:animate-slide-up flex-col gap-2 overflow-y-auto rounded-4 bg-surface-1 p-2 text-grey-12 shadow-popover outline-none dark:border dark:border-grey-5',
                className,
              )}
              collisionPadding={collisionPadding}
              data-testid="CONTEXT_MENU"
              {...restOfProps}
            >
              {children}
            </RadixContextMenu.Content>
          </RadixContextMenu.Portal>
        )}
      </RadixContextMenu.Root>
    );
  },
);

ContextMenu.displayName = 'ContextMenu';
